import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { OfflineCustomer } from '@/services/offline/customer';
const customer = new OfflineCustomer();

export class OffPlanFilterApi {
  async getFilter(params: any = {}, signal?: AbortSignal) {
    let path = `/api/CallPlan/ListCustomerOffPlanFilter?${qs.stringify(params)}`;
    try {
      if (window.isOffline) {
        return null;
      } else {
        const res = await axios.get(path, { signal });
        return res.data;
      }
    } catch (error) {
      if (axios.isCancel(error)) throw error;
      throw error;
    }
  }

  async getCustomerOffPlan(params: any = {}, signal?: AbortSignal) {
    let path = params.searchText
      ? `/api/CallPlan/SearchCustomerOffPlan?${qs.stringify(params)}`
      : `/api/CallPlan/ListOfCustomerOffPlan?${qs.stringify(params)}`;

    try {
      if (window.isOffline) {
        if (params.searchText) {
          return await customer.getSearchCustomer(params.searchText, params.filter);
        } else {
          return await customer.getCustomer(params.filter);
        }
      } else {
        const res = await axios.get(path, { signal });
        return res.data;
      }
    } catch (error) {
      if (axios.isCancel(error)) throw error;
      throw error;
    }
  }
}
